import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AbstractSearchService } from '../abstract-search.service';
import { LocaleService } from '../../../../../core/services/locale/locale.service';
import { WkfCfgFieldService } from '../../../../../core/redux/field/service/wkf/wkf-cfg-field.service';

@Injectable({
  providedIn: 'root'
})
export class WkfSearchService extends AbstractSearchService {

  constructor(
    translateService: TranslateService,
    cfgFieldService: WkfCfgFieldService,
    localeService: LocaleService
  ) {
    super(translateService, cfgFieldService, localeService);
  }
}
